import { Box } from "@mui/material";
import { Tooltip } from "../../../../components";
import { BG_COLORS, BORDER_COLORS, FONT_COLORS } from "../../../../constants";
import { ReactNode } from "react";

interface ITagProps {
  title: string | ReactNode;
  variant: "default" | "info" | "warning" | "success";
  tooltip?: string | ReactNode;
  badgeStyle?: boolean; // Explicit prop to enable badge styling
}

export const Tag: React.FunctionComponent<ITagProps> = ({
  tooltip,
  variant = "default",
  title,
  badgeStyle = false,
}) => {
  // Badge style only when explicitly enabled
  const isBadgeStyle = badgeStyle;

  return (
    <Tooltip title={tooltip} arrow>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isBadgeStyle ? "3px 5px" : "0 5px",
          height: isBadgeStyle ? "auto" : "26px",
          borderRadius: "4px",
          border: "1px solid",
          borderColor: BORDER_COLORS[variant],
          backgroundColor: BG_COLORS[variant],
          color: FONT_COLORS[variant],
          fontSize: isBadgeStyle ? "10px" : "12px",
          fontWeight: isBadgeStyle ? 900 : 500,
          lineHeight: isBadgeStyle ? "15px" : "17px",
          width: isBadgeStyle ? "35px" : "auto",
          textAlign: "center",
          // textDecorationLine: "underline",
          // textDecorationStyle: "dotted",
          // textDecorationColor: "#414651",
          // textUnderlineOffset: "2px",
        }}
      >
        {title}
      </Box>
    </Tooltip>
  );
};

export default Tag;
